import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular';

import packageJson from '../package.json';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.sentryEnvironment,
    release: packageJson.version,
    tracesSampleRate: 0,
    initialScope: {
      tags: { service: 'oremus-backoffice' },
    },
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
